import { render, staticRenderFns } from "./store-recommend.vue?vue&type=template&id=acba0650&scoped=true"
import script from "./store-recommend.vue?vue&type=script&lang=js"
export * from "./store-recommend.vue?vue&type=script&lang=js"
import style0 from "./store-recommend.vue?vue&type=style&index=0&id=acba0650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acba0650",
  null
  
)

export default component.exports